import { contentBasehost } from 'src/utils/environment';

export const CALLER_PAGE = 'categorypage';

export const iframeSourceString = `${contentBasehost}/services/1`;
